import API from '@services/API';
import { setError, startSpinner, stopSpinner } from '../../common/actionCreators';
import { APPLICATIONS_ACTION_TYPES } from '@constants/actionTypes/applicationsActionType';
import { configs } from '@constants/configs/configs';
import { API_STATUS } from '@constants/common.constants';

export const setApplications = applications => ({
    type: APPLICATIONS_ACTION_TYPES.SET_APPLICATIONS,
    applications
});

export const setHistoricalApplications = ({ applications, migrated = null, ticketId = null, referenceId = null, encryptedTicketId = null }) => ({
    type: APPLICATIONS_ACTION_TYPES.SET_HISTORICAL_APPLICATIONS,
    historicalApplications: applications,
    migrated,
    ticketId,
    referenceId,
    encryptedTicketId
});

export const setApplicationsError = () => ({
    type: APPLICATIONS_ACTION_TYPES.GET_APPLICATIONS_ERROR,
    payload: 'Cannot get applications'
});

export const setHistoricalApplicationsError = () => ({
    type: APPLICATIONS_ACTION_TYPES.GET_HISTORICAL_APPLICATIONS_ERROR,
    payload: 'Cannot get historical applications'
});

/************************

 # Async action creators

 ************************/

const actions = { setError, startSpinner, stopSpinner };

export const getApplications = (coverageYear) => async (dispatch, getState) => {
    const URL = configs.endpoints.APPLICATIONS_NEW.processReplacements({ coverageYear });
    const data = await API.getData(URL, dispatch, actions, true, getState());
    if (data) {
        dispatch(setApplications(data));
        return data;
    } else {
        dispatch(setApplicationsError());
    }
};

export const getHistoricalApplications = (coverageYear) => async (dispatch, getState) => {
    const URL = configs.endpoints.HISTORICAL_APPLICATIONS.processReplacements({ coverageYear });
    const response = await API.getData(URL, dispatch, actions, true, getState());
    const payload = response?.data;
    if (payload) {
        dispatch(
            setHistoricalApplications({
                applications: payload.myApplications ?? [],
                migrated: payload.migrated ?? null,
                ticketId: payload.ticketId ?? null,
                referenceId: payload.referenceId ?? null,
                encryptedTicketId: payload.encryptedTicketId ?? null
            })
        );
        return payload;
    }
    dispatch(setHistoricalApplicationsError());
};

export const createAccountMigrationTicket = (userRefId) => async (dispatch, getState) => {
    const trimmed = typeof userRefId === 'string' ? userRefId.trim() : '';
    if (!trimmed) {
        return undefined;
    }
    const URL = configs.endpoints.CREATE_ACCOUNT_MIGRATION_TICKET;
    const response = await API.postData([URL, { userRefId: trimmed }], dispatch, actions, true, getState());
    if (response?.status === API_STATUS.SUCCESS) {
        const ticketNumber =
            response?.data?.ticketNumber ?? null;
        const encryptedTicketId = response?.data?.encryptedTicketId ?? null;
        const { historicalMigration } = getState().individualPortal.applications;
        dispatch(
            setHistoricalApplications({
                migrated: historicalMigration?.migrated ?? null,
                ticketId: ticketNumber,
                referenceId: trimmed,
                encryptedTicketId,
            })
        );
        return { ...response, ticketNumber, encryptedTicketId };
    }
    return undefined;
};
